//import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginRounded from "@mui/icons-material/LoginRounded";
import logoC from "../assets/logoScuro.png";
import api from "./api/api";

const Login = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [resetEmail, setResetEmail] = useState("");
	const [resetMessage, setResetMessage] = useState(null);
	const [isResetting, setIsResetting] = useState(false);
	const [showResetModal, setShowResetModal] = useState(false);
	const navigate = useNavigate();

	const handleLogin = async (e) => {
		e.preventDefault();

		try {
			let result = await api.post("/login", {
				username: username,
				password: password,
			});
			sessionStorage.setItem("logged", "ok");
			sessionStorage.setItem("username", username);
			sessionStorage.setItem("email", result.data.email);
			sessionStorage.setItem("nome", result.data.nome + " " + result.data.cognome);
			sessionStorage.setItem("rank", result.data.rank);
			navigate("/Homepage");
		} catch (e) {
			if (e.response.data.message === "User Not found.") {
				alert("Utente non trovato");
			}

			if (e.response.data.message === "Invalid Password!") {
				alert("Password errata");
			}
		}
	};

	const openResetPanel = () => setShowResetModal(true);

	const handleReset = async (e) => {
		e.preventDefault();
		setResetMessage(null);
		if (!resetEmail) {
			setResetMessage({ type: "error", text: "Inserisci l'email." });
			return;
		}
		setIsResetting(true);
		try {
			await api.post("/resetPassword/request", { email: resetEmail });
			setResetMessage({ type: "success", text: "Email inviata. Controlla la casella per reimpostare la password." });
			setPassword("");
		} catch (err) {
			const text = err?.response?.data?.message || "Errore nel reset password.";
			setResetMessage({ type: "error", text });
		} finally {
			setIsResetting(false);
		}
	};

	return (
		<div
			className="auth-screen min-h-screen w-full flex items-center justify-center relative px-4 py-8"
		>
			<div className="relative z-10 w-full max-w-md">
				<div className="login-card w-full p-6 sm:p-8 space-y-7">
					<div className="auth-brand flex items-center gap-3 justify-center">
						<img className="w-12 h-12" src={logoC} alt="" />
						<div>
							<p className="auth-eyebrow text-sm">Accesso</p>
							<p className="auth-title text-2xl font-semibold">Prophet AI</p>
						</div>
					</div>

					<form autoComplete="off" className="space-y-5" onSubmit={handleLogin}>
						<div className="space-y-2">
							<label htmlFor="username" className="label-text">
								Username
							</label>
							<input
								type="text"
								name="username"
								id="username"
								value={username}
								className="input-text-login"
								placeholder="Inserisci l'username"
								required
								onChange={(e) => setUsername(e.target.value)}
							/>
						</div>
						<div className="space-y-2">
							<label htmlFor="password" className="label-text">
								Password
							</label>
							<input
								type="password"
								name="password"
								id="password"
								placeholder="Inserisci la password"
								value={password}
								className="input-text-login"
								required
								onChange={(e) => setPassword(e.target.value)}
							/>
						</div>
						<button type="submit" onClick={handleLogin} className="button-login">
							<LoginRounded fontSize="small" aria-hidden="true" />
							Entra
						</button>
					</form>

					<div className="text-center">
						<button type="button" onClick={openResetPanel} className="auth-link text-sm">
							Password dimenticata?
						</button>
					</div>
				</div>
			</div>

			{showResetModal && (
				<div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(12, 19, 31, 0.6)", backdropFilter: "blur(6px)" }}>
					<div className="login-card w-full max-w-md p-6 space-y-4">
						<div className="flex items-center justify-between">
							<p className="text-lg font-semibold">Recupera password</p>
							<button type="button" onClick={() => setShowResetModal(false)} className="auth-close text-xl" aria-label="Chiudi">
								×
							</button>
						</div>
						<p className="auth-description text-sm">Inserisci la tua email: ti invieremo un link per impostare una nuova password.</p>
						<form className="space-y-4" onSubmit={handleReset}>
							<div className="space-y-2">
								<label htmlFor="resetEmail" className="label-text">
									Email
								</label>
								<input
									type="email"
									name="resetEmail"
									id="resetEmail"
									placeholder="Inserisci l'email"
									value={resetEmail}
									className="input-text-login"
									required
									onChange={(e) => setResetEmail(e.target.value)}
								/>
							</div>
							<button type="submit" disabled={isResetting} className="button-login">
								{isResetting ? "Invio..." : "Invia link"}
							</button>
							{resetMessage && (
								<p className={`text-sm ${resetMessage.type === "error" ? "text-red-700" : "text-green-700"}`}>
									{resetMessage.text}
								</p>
							)}
						</form>
					</div>
				</div>
			)}
		</div>
	);
};

export default Login;
